module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x4.ce14d414.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x4.png
// module id = 2771
// module chunks = 11